import * as React from "react";
import { Servicio } from "../modelo/AdminServicio";
import { Modal, Row, Col, Button } from "react-bootstrap";
import * as moment from "moment";
import DatePicker from "react-datepicker";
import DatePickerSura from "../../../general/componentes/DatePicker";
import { Form } from "react-final-form";
import NumericInput from "../../../general/componentes/NumericInput";
import InterruptorSN from "../../config_general/componentes/InterruptorSN";
import InputTextBox from "../../config_general/componentes/InputTextBox";
import TextoInput from "../../../general/componentes/TextoInput";
import { TipoDatos } from "../../config_general/modelo/TipoDatos";

export class ModalGestionarServicio extends React.Component<ModalGestionarServicioProps, any> {

    constructor(props: any) {
        super(props);

        this.state = {
        };
    }

    render() {
        return (
            <div>
                <Modal bsSize="large" backdrop='static' show={this.props.show} onHide={this.cancelar}>
                    <Modal.Body>
                        {this.renderFormularioGlosas()}
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    renderFormularioGlosas = () => {
        const {
            esCrear,
            consecutivo,
            nombreServicio,
            descripcion,
            urlServicio,
            tablaTraza,
            snEnvioSat,
            snReciboSat,
            snEncriptarEnvioSat,
            snEncriptarReciboSat,
            fechaAlta,
            fechaBaja,
            intentos,
            tiempoIntento,
            servicioMinisterio,
            snGestionable,
            textoSelector,
            servicioDependientes,
            idCliente
        } = this.props;

        const dateFechaAlta = () => {
            if (fechaAlta) {
                const date = new Date(fechaAlta);
                return moment(date.setDate(date.getDate() + 1), DatePicker.DATE_FORMAT);
            }
            return undefined;
        };

        const dateFechaBaja = () => {
            if (fechaBaja) {
                const date = new Date(fechaBaja);
                return moment(date.setDate(date.getDate() + 1), DatePicker.DATE_FORMAT);
            }
            return undefined;
        };

        return (
            <div>
                <Form
                    onSubmit={this.onSubmit}
                    validate={this.validate}
                    initialValues={{
                        consecutivo: consecutivo,
                        nombreServicio: nombreServicio,
                        descripcion: descripcion,
                        urlServicio: urlServicio,
                        tablaTraza: tablaTraza,
                        snEnvioSat: snEnvioSat,
                        snReciboSat: snReciboSat,
                        snEncriptarEnvioSat: snEncriptarEnvioSat,
                        snEncriptarReciboSat: snEncriptarReciboSat,
                        fechaAlta: dateFechaAlta(),
                        fechaBaja: dateFechaBaja(),
                        intentos: intentos,
                        tiempoIntento: tiempoIntento,
                        servicioMinisterio: servicioMinisterio,
                        snGestionable: snGestionable,
                        textoSelector: textoSelector,
                        servicioDependientes: servicioDependientes,
                        idCliente: idCliente
                    }}
                    render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                        <form onSubmit={handleSubmit}>
                            <div className={"card"}>
                                <div className={"card-header"}>
                                    <h3 className={"panel-title"}>{this.props.titulo}</h3>
                                </div>
                                <div className={"card-body"}>
                                    <Row className={"form-group"}>
                                        <Col sm={2}>
                                            <label htmlFor="consecutivo">Consecutivo Servicio</label>
                                            <NumericInput name="consecutivo" disabled={!esCrear} />
                                        </Col>
                                        <Col sm={6}>
                                            <label htmlFor="nombreServicio">Nombre Servicio</label>
                                            <TextoInput name="nombreServicio" placeholder="Ingrese texto" maxLength={500} />
                                        </Col>
                                        <Col sm={4}>
                                            <label htmlFor="tablaTraza">Tabla BD</label>
                                            <TextoInput name={"tablaTraza"} placeholder="Ingrese valor" maxLength={500} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={12}>
                                            <label htmlFor="urlServicio">URL Servicio</label>
                                            <TextoInput name={"urlServicio"} maxLength={2000} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={12}>
                                            <label htmlFor="descripcion">Descripción</label>
                                            <InputTextBox name={"descripcion"} tamano={100} maxLength={2000} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={4}>
                                            <label htmlFor="intentos">Numero Intentos</label>
                                            <NumericInput name="intentos" />
                                        </Col>
                                        <Col sm={4}>
                                            <label htmlFor="tiempoIntento">Tiempo Intento en Minutos</label>
                                            <NumericInput name="tiempoIntento" />
                                        </Col>
                                        <Col sm={4}>
                                            <label htmlFor="servicioMinisterio">Codigo Ministerio</label>
                                            <TextoInput name={"servicioMinisterio"} maxLength={2000} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={4}>
                                            <label htmlFor="textoSelector">Texto Selector</label>
                                            <TextoInput name="textoSelector" placeholder="Ingrese texto del selector de servicios" maxLength={200} />
                                        </Col>
                                        <Col sm={4}>
                                            <label htmlFor="servicioDependientes">Servicios Dependientes</label>
                                            <TextoInput name="servicioDependientes" placeholder="Ingrese los servicios dependientes separados por ," maxLength={200} />
                                        </Col>
                                        <Col sm={4}>
                                            <label htmlFor="idCliente">ID Seguridad</label>
                                            <TextoInput name="idCliente" placeholder="Ingrese id de seguridad" maxLength={200} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={3}>
                                            <label htmlFor="snEnvioSat">Envio SAT</label>
                                            <InterruptorSN name={"snEnvioSat"} />
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="snReciboSat">Recibo SAT</label>
                                            <InterruptorSN name={"snReciboSat"} />
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="snEncriptarEnvioSat">Encriptar Envio</label>
                                            <InterruptorSN name={"snEncriptarEnvioSat"} />
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="snEncriptarReciboSat">Desencriptar Recibo</label>
                                            <InterruptorSN name={"snEncriptarReciboSat"} />
                                        </Col>
                                    </Row>
                                    <Row className={"form-group"}>
                                        <Col sm={3}>
                                            <label htmlFor="snGestionable">Es Gestionable</label>
                                            <InterruptorSN name={"snGestionable"} />
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="fechaAlta">Fecha Alta</label>
                                            <DatePickerSura name={"fechaAlta"} />
                                        </Col>
                                        <Col sm={3}>
                                            <label htmlFor="fechaBaja">Fecha Baja</label>
                                            <DatePickerSura name={"fechaBaja"} />
                                        </Col>
                                    </Row>
                                    <div style={{ marginTop: `25px` }}>
                                        <Modal.Footer>
                                            <Button type="submit" className={"btns btns-primary"} disabled={submitting || invalid} >Aceptar</Button>
                                            <Button className={"btns btns-secondary"} onClick={this.cancelar}>Cancelar</Button>
                                        </Modal.Footer>
                                    </div>
                                </div>
                            </div>
                        </form>
                    )}
                />
            </div>
        );
    }

    validate = (values: any) => {
        const errors = {
            consecutivo: undefined,
            fechaAlta: undefined,
            intentos: undefined,
            tiempoIntento: undefined,
            textoSelector: undefined
        };

        const validarRangoConsecutivo = (consecutivo: number) => consecutivo > 99 || consecutivo < 1;
        const validarRangoIntentos = (intento: number) => intento > 99 || intento < -1;
        const validarRangoTiempo = (tiempo: number) => tiempo > 9999 || tiempo < 0;

        if (!values.consecutivo) {
            errors.consecutivo = "Por favor ingrese el codigo del servicio";
        }
        else if (isNaN(values.consecutivo) || validarRangoConsecutivo(values.consecutivo)) {
            errors.consecutivo = "El consecutivo debe ser un numero entre 1 y 99";
        }

        if (!values.textoSelector)
            errors.textoSelector = "Por favor ingrese el texto para el selector";

        if (!values.fechaAlta)
            errors.fechaAlta = "Por favor ingrese la fecha de alta";

        if (values.intentos && (isNaN(values.intentos) || validarRangoIntentos(values.intentos)))
            errors.intentos = "Los intentos debe ser un numero entre -1 y 99";

        if (values.tiempoIntento && (isNaN(values.tiempoIntento) || validarRangoTiempo(values.tiempoIntento)))
            errors.tiempoIntento = "El tiempo de los intentos debe ser un numero entre 0 y 9999";

        return errors;
    }

    onSubmit = (values: any) => {
        const consecutivo = values.consecutivo ? Number(values.consecutivo) : undefined;
        const nombreServicio = values.nombreServicio ? values.nombreServicio.valueOf() : undefined;
        const descripcion = values.descripcion ? values.descripcion.valueOf() : undefined;
        const urlServicio = values.urlServicio ? values.urlServicio.valueOf() : undefined;
        const tablaTraza = values.tablaTraza ? values.tablaTraza.valueOf() : undefined;
        const snEnvioSat = values.snEnvioSat;
        const snReciboSat = values.snReciboSat;
        const snEncriptarEnvioSat = values.snEncriptarEnvioSat;
        const snEncriptarReciboSat = values.snEncriptarReciboSat;
        const fechaAlta = values.fechaAlta ? values.fechaAlta.format("YYYY-MM-DD").valueOf() : undefined;
        const fechaBaja = values.fechaBaja ? values.fechaBaja.format("YYYY-MM-DD").valueOf() : undefined;
        const intentos = values.intentos ? Number(values.intentos) : undefined;
        const tiempoIntento = values.tiempoIntento ? Number(values.tiempoIntento) : undefined;
        const servicioMinisterio = values.servicioMinisterio ? values.servicioMinisterio.valueOf() : undefined;
        const snGestionable = values.snGestionable;
        const textoSelector = values.textoSelector ? values.textoSelector.valueOf() : undefined;
        const servicioDependientes = values.servicioDependientes ? values.servicioDependientes.valueOf() : undefined;
        const idCliente = values.idCliente ? values.idCliente.valueOf() : undefined;

        const servicio: Servicio = {
            tipo: TipoDatos.SERVICIO,
            consecutivo: consecutivo,
            nombreServicio: nombreServicio,
            descripcion: descripcion,
            urlServicio: urlServicio,
            tablaTraza: tablaTraza,
            snEnvioSat: snEnvioSat,
            snReciboSat: snReciboSat,
            snEncriptarEnvioSat: snEncriptarEnvioSat,
            snEncriptarReciboSat: snEncriptarReciboSat,
            fechaAlta: fechaAlta,
            fechaBaja: fechaBaja,
            intentos: intentos,
            tiempoIntento: tiempoIntento,
            servicioMinisterio: servicioMinisterio,
            snGestionable: snGestionable,
            textoSelector: textoSelector,
            servicioDependientes: servicioDependientes,
            fechaIngresa: this.props.fechaIngresa,
            dniIngreso: this.props.dniIngreso,
            idCliente: idCliente
        };

        this.props.onAceptar(servicio);
    }

    cancelar = () => {
        this.props.onCancelar();
    }
}

interface ModalGestionarServicioProps {
    titulo: string,
    esCrear: boolean,
    consecutivo: number,
    nombreServicio: string,
    descripcion: string,
    urlServicio: string,
    tablaTraza: string,
    snEnvioSat: boolean,
    snReciboSat: boolean,
    snEncriptarEnvioSat: boolean,
    snEncriptarReciboSat: boolean,
    fechaAlta: string,
    fechaBaja: string,
    fechaIngresa: string,
    intentos: number,
    tiempoIntento: number,
    servicioMinisterio: string,
    dniIngreso: string,
    snGestionable: boolean,
    textoSelector: string,
    servicioDependientes: string,
    idCliente: string,
    show: boolean,
    onAceptar?: (servicio: Servicio) => void;
    onCancelar?: () => void;
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_servicios/componentes/ModalGestionarServicio.tsx